<template>
    <div>
        <b-row>
            <b-col>
                <b-card class="pb-12 barra-nuevos-productos" :style="cssVars">
                    <h4> {{$route.params.categoria}}</h4>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="tipo-vistas-card justify-content-md-center my-3">        
            <b-col cols="4" md="2">
                <b-button variant="light" @click="typeViewAction(1)" class="mr-2">
                    <b-icon icon="grid3x3-gap" > </b-icon>
                </b-button>
                <b-button variant="light" @click="typeViewAction(2)" class="mr-2">
                    <b-icon icon="grid" > </b-icon>
                </b-button>
                <b-button variant="light" @click="typeViewAction(3)">
                    <b-icon icon="list-ul" > </b-icon>
                </b-button>
            </b-col>  
            <b-col cols="2" md="1">
                <b-form-group>
                    <b-form-select
                    v-model="paginator.pageSize"
                    :options="pageSizeOptions"
                    @change="getItemsByCategory"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <hr>
        <b-row class="only-mobile-display">
            <b-col>
                <b-form-group>
                    <b-form-select
                    v-model="paginator.pageSize"
                    :options="pageSizeOptions"
                    @change="getItemsByCategory"
                    >
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="my-2">
            <b-col cols="12" class="justify-content-md-center"> 
                <div>
                    <b-pagination 
                        size="md" 
                        pills 
                        :total-rows="paginator.totalPage" 
                        v-model="paginator.page" 
                        :per-page="1" 
                        @input="changePage" 
                        first-number 
                        last-number>
                    </b-pagination>
                </div>
            </b-col>
        </b-row>
        <hr>
        <div>
            <div v-if="catalogo.length > 0 && displayItem === 1">
                <card-item :items="catalogo" @item-info="itemInfo($event)" @add-item="openAddModal($event)" />
            </div>
            <div v-else-if="catalogo.length > 0 && displayItem === 2">
                <card-item2 :items="catalogo" @item-info="itemInfo($event)" @add-item="openAddModal($event)" />
            </div>
            <div v-else-if="catalogo.length > 0 && displayItem === 3">
                <card-item3 :items="catalogo" @item-info="itemInfo($event)" @add-item="openAddModal($event)" />
            </div>
            <b-alert v-else variant="danger" show>
               Lo sentimos, no se han encontrado resultados para su busqueda.
            </b-alert>
        </div>
        <template v-if="catalogo.length > 0">
            <div class="text-end">
                <b-pagination 
                    size="md" 
                    pills 
                    :total-rows="paginator.totalPage" 
                    v-model="paginator.page" 
                    :per-page="1" 
                    @input="changePage" 
                    first-number 
                    last-number>
                </b-pagination>
            </div>
        </template>
        <addItem @close-modal="closeAddModal" :openModal="itemModal" :item="itemData"/>
    </div>
</template>

<script>
import { mapActions, mapState, mapMutations} from 'vuex'
import addItem from '@/components/AddItemToCart/AddItem.vue'
import CardItem from '../components/CardItemBase.vue'
import CardItem2 from '../components/CardItem2.vue'
import CardItem3 from '../components/CardItem3.vue'
export default {
    data(){
        return{
            displayItem: 1,
            catalogo: [],
            paginator: {
                page: 1,
                totalPage: 1,
                pageSize: 18
            },
            itemModal: false,
            itemData: '',
            pageSizeOptions: [
                { value: 18, text: '18' },
                { value: 24, text: '24' },
                { value: 48, text: '48' }
            ],
            orderOptions: [
                { value: 0, text: 'Orden inicial' },
                { value: 1, text: 'Productos (A-Z)' },
                { value: 2, text: 'Productos (Z-A)' }
            ]
        }
    },
    components: {
        addItem,
        CardItem,
        CardItem2,
        CardItem3
    },
    computed: {
        ...mapState('auth', ['user']),
        ...mapState('configuration', ['background']),
        cssVars() {
            return {
                '--border-bottom': this.background
            };
        },
    },
    watch: {
        '$route.params.categoryCode': function () {
        this.getItemsByCategory()
        }
    },
    created: function () {
        this.getItemsByCategory()
    },
    methods: {
         ...mapActions('configuration', {
          _getCartCount: 'getCartItemsCountByUser',
        }),
        ...mapMutations(['setLoading']),
        async getItemsByCategory(){
            this.catalogo = [];
            let pageOptions = { 
                categoryCode: this.$route.params.categoryCode,
                pageNumber: this.paginator.page,
                pageSize: this.paginator.pageSize,
            };
            this.setLoading(true)
            await this.$conectar.post('/articulos/categoria/get-items-category', pageOptions)
            .then(response =>{
                this.catalogo = response.data.items;
                this.paginator.totalPage = response.data.totalPages;
            })
            .catch(error => {
                console.log(error);
            })
            this.setLoading(false)
        },
        changePage(page){
            this.paginator.page = page;
            this.getItemsByCategory();
        },
        itemInfo(datos){
            this.$router.push({ name: 'ItemDetail', params:{ referencia: datos.codigo} });
        },
        openAddModal(item){
            this.itemModal = true;
            this.itemData = item;
        },
        closeAddModal(){
            this.itemModal = false;
            this.itemData = '';
        },
        typeViewAction(typeView){
            this.displayItem = typeView;
        }
           
        
    }
}
</script>
<style scoped>
.image-list-small { 
    max-width: 100px; 
    max-height: 100px;
}

.image-list img {
    max-width: 100%; 
    height:150px;
}

.image-list-small img {
    max-width: 100%; 
    height:120px;
}
.card-min-height {
    min-height: 100px;
}
.price-size{
    font-size: 18px;
}
.card-label-size{
    font-size:  18px;
}
.producto-agotado{
    font-size:  18px;
    color: red;
}

.barra-nuevos-productos{
    background-color: #fffffc;
    background-image: linear-gradient(200deg, #fffffc 0%, #cac7c7 84%);
    border-bottom: 5px solid var(--border-bottom);
}
.card-min-text{
    min-height: 90px;
}
.card-footer {
    border-top: 1px solid var(--border-bottom);
}
.icon-scale{
    transition: transform .4s;
    cursor: pointer;
}
.icon-scale:hover{
    transform: scale(1.2);
    color: var(--border-bottom);
}
.icon-info{
    color: var(--border-bottom);
    cursor: pointer;
}

.card-a-link-min-height {
   display:block;
    height:60px;
}

.texto-card-small{
    font-size: 13px;
}

.texto-card-medium{
    font-size: 14px;
}
.only-mobile-display{
    display:none
}

@media screen and (max-width: 800px) {
    .tipo-vistas-card{
        display: none;
    }
    .only-mobile-display{
        display:initial
    }
}
</style>